(function () {
  const intro = document.querySelector('[data-octa-intro]');
  if (!intro) return;

  const root = document.documentElement;
  const mark = intro.querySelector('[data-octa-intro-mark]');
  const introVideos = Array.from(intro.querySelectorAll('video'));
  const forceFromUrl = location.search.includes('octa-intro');
  const disabled = location.search.includes('octa-intro-off');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let dismissTimer;
  let interactionAbort;
  let active = false;
  let force = forceFromUrl;

  if (force) root.classList.add('octa-intro-force');

  function cssMs(name, fallback) {
    const value = getComputedStyle(root).getPropertyValue(name).trim();
    if (!value) return fallback;
    if (value.endsWith('ms')) return parseFloat(value);
    if (value.endsWith('s')) return parseFloat(value) * 1000;
    return parseFloat(value) || fallback;
  }

  function getHeroVideos() {
    return Array.from(document.querySelectorAll('.octa-home-hero video'));
  }

  function prepareVideo(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('autoplay', '');
    video.preload = 'auto';
  }

  function playVideo(video) {
    if (!video || reduceMotion) return;
    prepareVideo(video);
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  }

  function playVideos() {
    introVideos.concat(getHeroVideos()).forEach((video) => {
      video.muted = true;
      playVideo(video);
    });
  }

  function measureTarget() {
    const target = document.querySelector('#header-component .header-logo .octa-logo') ||
      document.querySelector('#header-component .header-logo');

    if (!target || !mark) return;

    const targetRect = target.getBoundingClientRect();
    const markRect = mark.getBoundingClientRect();
    const viewportCenterX = window.innerWidth / 2;
    const viewportCenterY = window.innerHeight / 2;
    const targetCenterX = targetRect.left + targetRect.width / 2;
    const targetCenterY = targetRect.top + targetRect.height / 2;
    const scale = markRect.width > 0 ? targetRect.width / markRect.width : 0.12;

    root.style.setProperty('--octa-intro-end-x', `${targetCenterX - viewportCenterX}px`);
    root.style.setProperty('--octa-intro-end-y', `${targetCenterY - viewportCenterY}px`);
    root.style.setProperty('--octa-intro-end-scale', String(Math.max(0.04, Math.min(0.4, scale))));
  }

  function finish() {
    active = false;
    interactionAbort?.abort();
    intro.hidden = true;
    intro.classList.remove('is-ready', 'is-leaving');
    root.classList.remove('octa-intro-active', 'octa-intro-leaving');
    playVideos();
  }

  function dismiss() {
    if (!active || intro.classList.contains('is-leaving')) return;

    window.clearTimeout(dismissTimer);
    measureTarget();
    root.classList.add('octa-intro-leaving');
    intro.classList.add('is-leaving');

    window.setTimeout(finish, cssMs('--octa-intro-duration', 900) + 120);
  }

  function scheduleDismiss() {
    window.clearTimeout(dismissTimer);
    dismissTimer = window.setTimeout(dismiss, cssMs('--octa-intro-hold', 1300));
  }

  function enabledBySettings() {
    return getComputedStyle(root).getPropertyValue('--octa-intro-enabled').trim() !== '0';
  }

  function armDismissInteractions() {
    interactionAbort?.abort();
    interactionAbort = new AbortController();
    const opts = { passive: true, signal: interactionAbort.signal };
    ['pointerdown', 'wheel', 'touchmove', 'keydown'].forEach((eventName) => {
      window.addEventListener(eventName, dismiss, opts);
    });
  }

  function retryAfterInteraction() {
    const retry = () => playVideos();
    ['pointerdown', 'touchstart', 'keydown'].forEach((eventName) => {
      window.addEventListener(eventName, retry, { passive: true, once: true });
    });
  }

  function start(options = {}) {
    if (options.force) {
      force = true;
      root.classList.add('octa-intro-force');
    }

    if (disabled || (!force && !enabledBySettings()) || (reduceMotion && !force)) {
      finish();
      return;
    }

    active = true;
    intro.hidden = false;
    intro.classList.remove('is-leaving');
    root.classList.remove('octa-intro-leaving');
    root.classList.add('octa-intro-active');
    playVideos();
    armDismissInteractions();

    requestAnimationFrame(() => {
      measureTarget();
      intro.classList.add('is-ready');
      scheduleDismiss();
    });
  }

  window.addEventListener('resize', measureTarget, { passive: true });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') playVideos();
  });
  window.addEventListener('load', playVideos, { once: true });
  retryAfterInteraction();

  window.OctaIntro = {
    replay: () => start({ force: true }),
    dismiss,
    start,
  };

  start();
})();
